export enum OnlineItemAuthorizationTrigger {
  ItemSale = 'ItemSale',
  TransactionComplete = 'TransactionComplete',
  Total = 'Total',
}

export enum OnlineItemExternalId {
  InBarcode = 'InBarcode',
  SecondBarcode = 'SecondBarcode',
  Card = 'Card',
}

export enum SellingBehaviorType {
  OnlineItemType = 'OnlineProduct',
}
